"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils");

var _fieldUtils = require("./fieldUtils");

var _FieldRadio = require("./FieldRadio");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getRadioIndexFromValue = function getRadioIndexFromValue(value, radioOptions) {
  return radioOptions.findIndex(function (radio) {
    return radio.value === value;
  });
};

var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  function RadioGroup(props) {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RadioGroup).call(this, props));
    _this.state = {
      defaultValue: null,
      selectedValue: null,
      focusedValue: null
    };
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.gotoFirstRadio = _this.gotoFirstRadio.bind(_assertThisInitialized(_this));
    _this.gotoLastRadio = _this.gotoLastRadio.bind(_assertThisInitialized(_this));
    _this.gotoPreviousRadio = _this.gotoPreviousRadio.bind(_assertThisInitialized(_this));
    _this.gotoNextRadio = _this.gotoNextRadio.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleKeydown = _this.handleKeydown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          doFocus = _this$props.doFocus,
          radioOptions = _this$props.radioOptions;
      var selectedValue = this.state.selectedValue;

      if (doFocus) {
        var radioToFocus = selectedValue || radioOptions[0] && radioOptions[0].value;
        this.focusRadio(radioToFocus);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var selectedValue = this.state.selectedValue;
      var handleChange = this.props.handleChange;

      if (selectedValue !== null && selectedValue !== prevState.selectedValue) {
        handleChange(selectedValue);
      }
    }
  }, {
    key: "focusRadio",
    value: function focusRadio(radio) {
      var doSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (doSelect) {
        this.setState({
          focusedValue: radio,
          selectedValue: radio
        });
      } else {
        this.setState({
          focusedValue: radio
        });
      }
    }
  }, {
    key: "gotoFirstRadio",
    value: function gotoFirstRadio() {
      var selectedValue = this.state.selectedValue;
      var radioOptions = this.props.radioOptions;
      var firstRadio = radioOptions[0] && radioOptions[0].value; // only if we already have selected a value should we
      // select a new value when moving focus

      this.focusRadio(firstRadio, selectedValue !== null);
    }
  }, {
    key: "gotoLastRadio",
    value: function gotoLastRadio() {
      var selectedValue = this.state.selectedValue;
      var radioOptions = this.props.radioOptions;
      var lastRadio = radioOptions[radioOptions.length - 1].value; // only if we already have selected a value should we
      // select a new value when moving focus

      this.focusRadio(lastRadio, selectedValue !== null);
    }
  }, {
    key: "gotoPreviousRadio",
    value: function gotoPreviousRadio(radio) {
      var selectedValue = this.state.selectedValue;
      var radioOptions = this.props.radioOptions;
      var index = getRadioIndexFromValue(radio, radioOptions); // If the current radio is already the first radio, circle round to the last radio

      if (index === 0) {
        this.gotoLastRadio();
      } else {
        // Else go to the previous radio
        var prevRadio = radioOptions[index - 1].value; // only if we already have selected a value should we
        // select a new value when moving focus

        this.focusRadio(prevRadio, selectedValue !== null);
      }
    }
  }, {
    key: "gotoNextRadio",
    value: function gotoNextRadio(radio) {
      var selectedValue = this.state.selectedValue;
      var radioOptions = this.props.radioOptions;
      var index = getRadioIndexFromValue(radio, radioOptions); // If the current radio is already the last radio, circle round to the first radio

      if (index === radioOptions.length - 1) {
        this.gotoFirstRadio();
      } else {
        // Else go to the next radio
        var nextRadio = radioOptions[index + 1].value; // only if we already have selected a value should we
        // select a new value when moving focus

        this.focusRadio(nextRadio, selectedValue !== null);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event, radio) {
      event.preventDefault();
      this.focusRadio(radio, true);
    }
    /**
     * Per the WAI ARIA Radio Group Design Pattern the following interaction is supported:
     *
     * Right Arrow and Down Arrow: move focus to the next radio button in the group,
     *      uncheck the previously focused button, and check the newly focused button.
     *      If focus is on the last button, focus moves to the first button.
     *
     * Left Arrow and Up Arrow: move focus to the previous radio button in the group,
     *      uncheck the previously focused button, and check the newly focused button.
     *      If focus is on the first button, focus moves to the last button.
     *
     * Space: checks the focused radio button if it is not already checked.
     */

  }, {
    key: "handleKeydown",
    value: function handleKeydown(event, radio) {
      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          event.preventDefault();
          this.gotoPreviousRadio(radio);
          break;

        case 'ArrowRight':
        case 'ArrowDown':
          event.preventDefault();
          this.gotoNextRadio(radio);
          break;

        case 'Enter':
        case ' ':
        case 'Spacebar':
          // for older browsers
          event.preventDefault();
          this.focusRadio(radio, true);
          break;

        default:
          break;
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event, radio) {
      this.focusRadio(radio);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.focusRadio(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          name = _this$props2.name,
          cashbotName = _this$props2.cashbotName,
          containerClass = _this$props2.containerClass,
          radioButtonClass = _this$props2.radioButtonClass,
          legend = _this$props2.legend,
          radioOptions = _this$props2.radioOptions,
          styleType = _this$props2.styleType,
          checkmarkClass = _this$props2.checkmarkClass;
      var _this$state = this.state,
          selectedValue = _this$state.selectedValue,
          focusedValue = _this$state.focusedValue;
      var focusableValue = selectedValue || focusedValue || radioOptions[0] && radioOptions[0].value; // prepare radio buttons

      var radioButtons = radioOptions.map(function (_ref, index) {
        var value = _ref.value,
            children = _ref.children;
        var isChecked = value === selectedValue;
        var isFocused = value === focusedValue;
        var isFocusable = value === focusableValue;
        var radioId = "".concat(name, "-").concat(index);
        return _react.default.createElement(_FieldRadio.FieldRadio, {
          key: radioId,
          id: radioId,
          value: value,
          cssClass: radioButtonClass,
          styleType: styleType,
          checkmarkClass: checkmarkClass,
          isChecked: isChecked,
          isFocused: isFocused,
          tabIndex: isFocusable ? 0 : -1,
          handleClick: _this2.handleClick,
          handleKeydown: _this2.handleKeydown,
          handleFocus: _this2.handleFocus,
          handleBlur: _this2.handleBlur
        }, children);
      });
      return _react.default.createElement("div", _extends({}, (0, _utils.getCashbotAttrs)(name, cashbotName), {
        className: containerClass,
        role: "radiogroup",
        "aria-label": legend,
        tabIndex: -1
      }), radioButtons);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var defaultValue = props.defaultValue,
          radioOptions = props.radioOptions;
      var prevDefaultValue = state.defaultValue; // only update selectedValue if the defaultValue has been updated externally

      if (defaultValue !== prevDefaultValue) {
        var selectedIndex = getRadioIndexFromValue(defaultValue, radioOptions); // only set selectedValue to defaultValue if it exists in the radioOptions

        var newSelectedValue = selectedIndex !== -1 ? radioOptions[selectedIndex].value : null;
        return {
          selectedValue: newSelectedValue,
          defaultValue: defaultValue
        };
      }

      return null;
    }
  }]);

  return RadioGroup;
}(_react.default.Component);

exports.RadioGroup = RadioGroup;
RadioGroup.defaultProps = {
  defaultValue: null,
  styleType: 'radiobutton',
  containerClass: null,
  radioButtonClass: 'radio-button',
  checkmarkClass: 'radio-icon',
  doFocus: false
};
RadioGroup.propTypes = {
  name: _propTypes.default.string.isRequired,
  legend: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  styleType: _propTypes.default.oneOf(['radiobutton', 'picker', 'checkedpicker']),
  containerClass: _propTypes.default.string,
  radioButtonClass: _propTypes.default.string,
  checkmarkClass: _propTypes.default.string,
  radioOptions: _fieldUtils.radioOptionsPropTypes.isRequired,
  handleChange: _propTypes.default.func.isRequired,
  doFocus: _propTypes.default.bool
};